import { render, staticRenderFns } from "./AdminAdsHome.vue?vue&type=template&id=7c4b74b7&scoped=true"
import script from "./AdminAdsHome.vue?vue&type=script&lang=js"
export * from "./AdminAdsHome.vue?vue&type=script&lang=js"
import style0 from "./AdminAdsHome.vue?vue&type=style&index=0&id=7c4b74b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b74b7",
  null
  
)

export default component.exports